import { SecurityStatus } from '@shared/enums/security-status';
import { SecurityStatusName } from '@shared/enums/security-status-name';

export function getSecurityStatusNameById(statusId?: number): string {
  switch (statusId) {
    case SecurityStatus.Approved:
      return SecurityStatusName.Approved;
    case SecurityStatus.PendingApproval:
      return SecurityStatusName.PendingApproval;
    case SecurityStatus.InformationRequired:
      return SecurityStatusName.InformationRequired;
    default:
      return SecurityStatusName.PendingApproval;
  }
}
